import { useEffect, useState } from "react"
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";

const SalesRepSales = () => {

    const [sales, setSales] = useState([])
    const [sliceCount, setSliceCount] = useState({ from: 0, to: 15 })

    const addSlice = () => {
        if ((sliceCount.to >= sales.length)) {
            setSliceCount({ from: sliceCount.from, to: sliceCount.to })
        } else {
            setSliceCount({ from: sliceCount.to, to: sliceCount.to + 15 })
            document.querySelector('#table-container').scrollTo(0, 0)
        }
    }

    const cutSlice = () => {
        if ((sliceCount.from <= 0)) {
            setSliceCount({ from: sliceCount.from, to: sliceCount.to })
        } else {
            setSliceCount({ from: sliceCount.from - 15, to: sliceCount.from })
            document.querySelector('#table-container').scrollTo(0, 0)
        }
    }

    useEffect(() => {
        setSales([])
    }, [])

    return (
        <>
            <div className=" h-[10vh] flex justify-center items-end">
                <div className=" w-[95%]">
                    <form action="" className=" relative inline-block w-full">
                        <input type="text" className=" w-full py-2 px-4 pr-12" placeholder="Search Reciept Number" name="" id="" />
                        <button className=" absolute right-0 top-[50%] -translate-y-[50%]" type="submit"><IoSearch /></button>
                    </form>
                </div>
            </div>
            <div className=" h-[70vh] flex justify-center items-start pt-6">
                <div className=" w-[95%] max-h-[95%] border-2 border-slate-300 rounded-md overflow-y-auto overflow-x-auto small-scrollbar scrollbar">
                    <table className=" w-full relative">
                        <thead className=" bg-tripstore-black text-white sticky top-0 z-[1]">
                            <tr className=" text-nowrap *:py-1 *:px-3">
                                <td>S/N</td>
                                <td>Reciept No.</td>
                                <td>Date & Time</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (sales.length > 0) ?
                                    <>
                                        {
                                            sales.slice(sliceCount.from, sliceCount.to).map((item, index) => (
                                                <tr key={index} className=" *:py-1 *:px-3 even:bg-slate-200 cursor-pointer hover:bg-slate-300 active:bg-tripstore-black active:text-white">
                                                    <td>{index + 1 + sliceCount.from}</td>
                                                    <td>Reciept No.</td>
                                                    <td>Date & Time</td>
                                                </tr>
                                            ))
                                        }
                                    </>
                                    :
                                    <tr>
                                        <td colSpan={10000} className=" py-1 px-3 text-center text-gray-500 font-semibold">No Sales</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className=" h-[10vh] w-[95%] m-auto flex justify-between items-center">
                <button onClick={() => cutSlice()} className=" flex items-center gap-4 hover:bg-slate-200"><FaAngleLeft /> <span className=" hidden md:inline">Previous</span></button>
                <div className={`${(sales.length <= 0) && " hidden"} text-sm font-semibold text-gray-500`}>Showing {1 + sliceCount.from} to {(sliceCount.to >= sales.length) ? sales.length : sliceCount.to} of {sales.length}</div>
                <button onClick={() => addSlice()} className=" flex items-center gap-4 hover:bg-slate-200"><span className=" hidden md:inline">Next</span> <FaAngleRight /></button>
            </div>
        </>
    )
}

export default SalesRepSales